<template>
  <div class="cards mx-auto shadow cards-height blog">
    <div
      class="d-flex justify-content-center mb-5 border-dark border-top"
      v-if="isLoading"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div>
      <div
        class="bg-white d-inline-block w-100 border-dark border-bottom no-wrap-size-undefined p-2 blog-title"
      >
        <h1>{{ item.title }}</h1>
      </div>
      <div class="bg-white d-inline-block w-100 border-dark border-bottom p-2">
        {{ formatDate(item.datetime) }}
      </div>
      <div class="m-4">
      <div class="bg-white p-4" v-html="item.blog"></div>
      </div>
    </div>
  </div>
</template>

<script>
import blogService from "@/services/blogService";
import testService from "@/services/testService";
import moment from "moment";
import { APP_CONFIG } from "@/common/flags";

export default {
  name: "BlogsView",
  data() {
    return {
      item: null,
      isLoading: false,
    };
  },
  created() {
    this.GetBlogAsync();
  },
  watch: {
    '$route': 'GetBlogAsync'
  },
  methods: {
    async GetBlogAsync() {
      //async GetBlogsAsync() {
      this.isLoading = true;
      let response = null;
      if (APP_CONFIG.ENV === "PROD") {
        response = await blogService.getBlogsAsync();
        // var response = await testService.getBlogById(this.$route.params.id);
        this.isLoading = false;
        // this.item = response;
        this.item = response.data.blogs[this.$route.params.id-1];
      } else {
        // var response = await blogService.getBlogsAsync();
        response = await testService.getBlogById(this.$route.params.id);
        this.isLoading = false;
        this.item = response;
        // this.item = response.data.blogs[this.$route.params.id-1];        
      }
    },
    formatDate(datetime) {
      return moment(datetime).format("MMM Do YYYY");
    }
  }
};
</script>

<style lang="scss">
.blog {
  margin-bottom: 5rem;
  .h1 {
    margin-bottom: 0rem;
  }
  // .blog-title {
    // background-size: cover; /* Resize the background image to cover the entire container */    
    // background-image: url("../assets/vue-bg.jpg");
    // background-color: #fff;
  // }
}
</style>
